
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs';



import { API } from '.././core/app-config';
import { ResponseMessage, PagerList, FPResponse, Country, ContractType } from '.././shared/shared.model';
import {
    CustomerStatus, Customer, CustomerList, CustomerType, CustomerTitle, TemplateDetails, PreferredContact, CTBusinessHour,
    CustomerAddress, AddressList, CountryList, Regions, AddressTypes, ContactList, ContactType, CustomerCFModel,
    CustomerContact, AddressName, BillingAccountList, BillingAccount, RecentWorkOrder, CustomerEquipment, CustomerEquipmentsList, CustomerDetailsListEntity, PrimaryBillingAddress, CustomerDetails, CustomerAutoComp,
    Specialinfo, ContactCFModel, EquipmentCFModel, CustomerPreferTechListEntity, Vendor, Technician, CustomerPreferTech, CustomerPreferType, CustomerPMList, BrandList, ModelList, BusinessHour, Priority, CustomerAttachmentEntity,
    CustomerAttachment, CustomerHolidayTemplate, CustomerVendor, CustomerVendorEntity,AddCustomerEntity,
    CustomerMultipleLogin

} from './customer.models';
import { ConfigMasterEntity } from '../admin/auto-sms/sms-template.model';

@Injectable()
export class CustomerService {

    // private states: Observable<State[]>;

    constructor(private http: Http) { }





    getTemplateList(CompanyId: number): Observable<TemplateDetails[]> {
        return this.http.get(API.HOLIDAY + "/GetTemplateList/" + CompanyId).pipe(map(res => res.json()));
    }

    getCustomerTitle(CompanyId: number, Id: number): Observable<CustomerTitle[]> {
        return this.http.get(API.CONFIGMASTER + "/GetAll/" + CompanyId + "/" + Id).pipe(map(res => res.json()));
    }

    getPreferredContact(CompanyId: number, Id: number): Observable<PreferredContact[]> {
        return this.http.get(API.CONFIGMASTER + "/GetAll/" + CompanyId + "/" + Id).pipe(map(res => res.json()));
    }



    getCustomerTypes(companyId: number): Observable<CustomerType[]> {
        return this.http.get(API.CUSTOMER + '/GetCustomerTypes/' + companyId).pipe(map(res => res.json()));
    }

    getCustomerStatus(companyId: number): Observable<CustomerStatus[]> {
        return this.http.get(API.CUSTOMER + '/GetCustomerStatus/' + companyId).pipe(map(res => res.json()));
    }



    getCustomers(customer: Customer, p: PagerList): Observable<CustomerList> {
        return this.http.post(API.CUSTOMER + '/GetAll/?SortBy=' + p.SortBy + '&OrderBy=' + p.OrderBy + '&StartRecord=' + p.StartRecord + '&EndRecord=' + p.EndRecord + '&SearchBy=' + customer.SearchText, customer).pipe(map(this.extractData));
    }

    getCustomer(companyId: number, customerId): Observable<Customer> {
        return this.http.get(API.CUSTOMER + '/GetCustomer/?CompanyId=' + companyId + '&CustomerId=' + customerId).pipe(map(res => res.json()));
    }

    //  searchCustomers(customerdetail: Customerdetails): Observable<CustomerDetailsListEntity> {
    //     return this.http.post(API.CUSTOMER + "/GetCustomerList", customerdetail).map<CustomerDetailsListEntity>(res => res.json());
    // }WithCF
    insertCustomerWithCF(customer: CustomerCFModel): Observable<FPResponse> {
        return this.http.post(API.CUSTOMER + '/InsertCustomerWithCF', customer).pipe(map(res => res.json()));
    }



    updateCustomerWithCF(customer: CustomerCFModel): Observable<FPResponse> {
        return this.http.put(API.CUSTOMER + '/UpdateCustomerWithCF', customer).pipe(map(res => res.json()));
    }
    insertCustomer(customer: Customer): Observable<FPResponse> {
        return this.http.post(API.CUSTOMER + '/InsertCustomer', customer).pipe(map(res => res.json()));
    }

    updateCustomer(customer: Customer): Observable<FPResponse> {
        return this.http.put(API.CUSTOMER + '/UpdateCustomer', customer).pipe(map(res => res.json()));
    }

    //added by nagarjuna for updateing iscustomerTypebussinesshour field in refcustomer Master 28/03/2019

    updateCustomerTypeBusinessHour(CompanyId: number, CustomerId: number, IsCustomerTypeBusinessHour: number, IsCustomerTypeHoliday: number, HolidayTemplateId: number): Observable<FPResponse> {
        return this.http.get(API.CUSTOMER + '/CustomerTypeBussinessHour/' + CompanyId + '/' + CustomerId + '/' + IsCustomerTypeBusinessHour + '/' + IsCustomerTypeHoliday + '/' + HolidayTemplateId).pipe(map(res => res.json()));
    }

    getCustomerTypeBusinessHour(companyId: number, CustomerTypeId: number): Observable<CTBusinessHour[]> {
        return this.http.get(API.CUSTOMERTYPE + '/GetBusinessHour/' + companyId + '/' + CustomerTypeId).pipe(map(this.extractData));
    }


    //added by nagarjuna for Holiday template 11/06/2019
    getCustomerTypeHolidayTemplate(companyId: number, CustomerId: number): Observable<CustomerHolidayTemplate[]> {
        return this.http.get(API.CUSTOMER + '/GetCustomerTypesHoliday/' + companyId + '/' + CustomerId).pipe(map(this.extractData));
    }
    //added by nagarjuna for Holiday template 11/06/2019
    getCustomerHolidayTemplate(companyId: number, CustomerId: number): Observable<CustomerHolidayTemplate[]> {
        return this.http.get(API.CUSTOMER + '/GetCustomerHoliday/' + companyId + '/' + CustomerId).pipe(map(this.extractData));
    }


    deleteCustomer(companyId: number, customerId: number): Observable<FPResponse> {
        return this.http.delete(API.CUSTOMER + '/Delete?CompanyId=' + companyId + '&CustomerId=' + customerId).pipe(map(res => res.json()));
    }

    GetAddressTypes() {
        return this.http.get(API.CUSTOMER + "/GetAddressTypes").pipe(map(resp => resp.json()));
    }
    GetCountry(isActive: number, companyId: number) {
        return this.http.get(API.REGION + '/GetCountry?isActive=' + isActive + '&CompanyId=' + companyId).pipe(map(resp => resp.json()));
    }
    // GetCompanyCountry(companyId: number) {
    //     return this.http.get(API.COMPANY + '/GetOperationalCountries/'+companyId).map(resp => resp.json());
    // }
    GetCountryList(activeId: number): Observable<CountryList[]> {
        return this.http.get(API.REGION + '/GetCountry?IsActive=' + activeId).pipe(map(res => res.json()));
    }
    GetRegionList(CompanyId: number) {
        return this.http.get(API.CUSTOMER + "/GetRegionList/" + CompanyId).pipe(map(resp => resp.json()));
    }
    /**Save Customer Address */
    insertAddress(customeraddress: CustomerAddress): Observable<FPResponse> {
        return this.http.post(API.CUSTOMER + "/AddCustomerAddress", customeraddress).pipe(map(resp => resp.json()));
    }
    /** Edit Customer Address */
    updateAddress(customeraddress: CustomerAddress): Observable<FPResponse> {
        return this.http.post(API.CUSTOMER + "/EditCustomerAddress", customeraddress).pipe(map(resp => resp.json()));
    }

    getAddress(companyID: number, customerId: number, customerAddressId: number) {
        return this.http.get(API.CUSTOMER + "/GetAddress/?CompanyId=" + companyID + '&CustomerAddressId=' + customerAddressId).pipe(map(resp => resp.json()));
    }

    getAddresses(customerId: number, p: PagerList): Observable<AddressList> {
        return this.http.get(API.CUSTOMER + '/GetAllAddress/?CompanyId=' + p.CompanyId + '&CustomerId=' + customerId + '&SortBy=' + p.SortBy + '&StartRecord=' + p.StartRecord + '&EndRecord=' + p.EndRecord).pipe(map(this.extractData));
    }

    deleteAddress(companyId: number, customerId: number, customerAddressId: number): Observable<FPResponse> {
        return this.http.delete(API.CUSTOMER + '/DeleteCustomerAddress?CompanyId=' + companyId + '&CustomerId=' + customerId + '&CustomerAddressId=' + customerAddressId).pipe(map(res => res.json()));
    }
    Checkcustomerdetails(companyId: number, customerId: number): Observable<FPResponse> {
        return this.http.get(API.CUSTOMER + '/GetCustomerDetailscheck?CompanyId=' + companyId + '&CustomerId=' + customerId ).pipe(map(res => res.json()));
    }
    //contact Start
    getContactType(CompanyId: number, Id: number): Observable<ContactType[]> {
        return this.http.get(API.CONFIGMASTER + "/GetAll/" + CompanyId + "/" + Id).pipe(map(this.extractData));
    }
    getAddressName(companyId: number, customerId: number): Observable<AddressName[]> {
        return this.http.get(API.CUSTOMER + "/GetAddressNameDD/?CompanyId=" + companyId + "&CustomerId=" + customerId).pipe(map(this.extractData));
    }
    getContacts(customerId: number, p: PagerList): Observable<ContactList> {
        return this.http.get(API.CUSTOMER + '/GetContacts/?CompanyId=' + p.CompanyId + '&CustomerId=' + customerId + '&SortBy=' + p.SortBy + '&StartRecord=' + p.StartRecord + '&EndRecord=' + p.EndRecord).pipe(map(this.extractData));
    }
    getContact(companyId: number, customerContactId: number): Observable<CustomerContact> {
        return this.http.get(API.CUSTOMER + '/GetContact/?CompanyId=' + companyId + '&CustomerContactId=' + customerContactId).pipe(map(this.extractData));
    }
    insertContactWithCF(cc: ContactCFModel): Observable<FPResponse> {
        return this.http.post(API.CUSTOMER + '/AddCustomerContactWithCF', cc).pipe(map(res => res.json()));
    }
    insertContact(cc: CustomerContact): Observable<FPResponse> {
        return this.http.post(API.CUSTOMER + '/AddCustomerContact', cc).pipe(map(res => res.json()));
    }
    updateContactWithCF(cc: ContactCFModel): Observable<FPResponse> {
        return this.http.put(API.CUSTOMER + '/UpdateCustomerContactWithCF', cc).pipe(map(res => res.json()));
    }
    updateContact(cc: CustomerContact): Observable<FPResponse> {
        return this.http.put(API.CUSTOMER + '/UpdateCustomerContact', cc).pipe(map(res => res.json()));
    }
    deleteContact(companyId: number, customerContactId: number): Observable<FPResponse> {
        return this.http.delete(API.CUSTOMER + '/DeleteCustomerContact?CompanyId=' + companyId + '&CustomerContactId=' + customerContactId).pipe(map(res => res.json()));
    }
    //contact End
    getBillingAccounts(customerId: number, p: PagerList): Observable<BillingAccountList> {
        return this.http.get(API.CUSTOMER + '/GetBillingAccounts/?CompanyId=' + p.CompanyId + '&CustomerId=' + customerId + '&SortBy=' + p.SortBy + '&StartRecord=' + p.StartRecord + '&EndRecord=' + p.EndRecord).pipe(map(this.extractData));
    }
    getBillingAccount(companyId: number, customerId: number, billingAccountId: number): Observable<BillingAccount> {
        return this.http.get(API.CUSTOMER + '/GetBillingAccount/?CompanyId=' + companyId + '&CustomerId=' + customerId + '&BillingAccountId=' + billingAccountId).pipe(map(this.extractData));
    }
    insertBillingAccount(cc: BillingAccount): Observable<FPResponse> {
        return this.http.post(API.CUSTOMER + '/InsertBillingAccount', cc).pipe(map(res => res.json()));
    }
    updateBillingAccount(cc: BillingAccount): Observable<FPResponse> {
        return this.http.put(API.CUSTOMER + '/UpdateBillingAccount', cc).pipe(map(res => res.json()));
    }
    deleteBillingAccount(companyId: number, customerId: number, billingAccountId: number, addressId: number): Observable<FPResponse> {
        return this.http.delete(API.CUSTOMER + '/DeleteBillingAccount?CompanyId=' + companyId + '&CustomerId=' + customerId + '&BillingAccountId=' + billingAccountId + '&BillingAddressId=' + addressId).pipe(map(res => res.json()));
    }
    //Equipment Start

    getServiceAddressName(companyId: number, customerId: number): Observable<AddressName[]> {
        return this.http.get(API.CUSTOMER + "/GetServiceAddressName/?CompanyId=" + companyId + "&CustomerId=" + customerId).pipe(map(this.extractData));
    }
    getEquipments(customerId: number, p: PagerList): Observable<CustomerEquipmentsList> {
        return this.http.get(API.CUSTOMER + '/GetEquipments/?CompanyId=' + p.CompanyId + '&CustomerId=' + customerId + '&SortBy=' + p.SortBy + '&StartRecord=' + p.StartRecord + '&EndRecord=' + p.EndRecord).pipe(map(this.extractData));
    }
    getEquipment(companyId: number, customerId: number, customerEquipmentId: number): Observable<CustomerEquipment> {
        return this.http.get(API.CUSTOMER + '/GetEquipment/?CompanyId=' + companyId + '&CustomerId=' + customerId + '&CustomerEquipmentId=' + customerEquipmentId).pipe(map(this.extractData));
    }
    insertEquipment(ce: EquipmentCFModel): Observable<FPResponse> {
        return this.http.post(API.CUSTOMER + '/InsertEquipment', ce).pipe(map(res => res.json()));
    }
    updateEquipment(ce: EquipmentCFModel): Observable<FPResponse> {
        return this.http.put(API.CUSTOMER + '/UpdateEquipment', ce).pipe(map(res => res.json()));
    }
    deleteEquipment(companyId: number, customerId: number, customerEquipmentId): Observable<FPResponse> {
        return this.http.delete(API.CUSTOMER + '/DeleteEquipment?CompanyId=' + companyId + '&CustomerId=' + customerId + '&CustomerEquipmentId=' + customerEquipmentId).pipe(map(res => res.json()));
    }
    //Equipment end

    getRecentOrders(CustomerId: number, CompanyId: number, LoginId: number, RecCount: number, RecordDays: number) {
        return this.http.get(API.WORKORDER + "/GetRecentOrdersHistory/" + CompanyId + "/" + CustomerId + "/" + LoginId + "/" + null + "/" + RecCount + "/" + RecordDays).pipe(map(resp => resp.json()));
    }

    /**Customer Lookup API */
    searchCustomers(customerdetail: CustomerDetails): Observable<CustomerDetailsListEntity> {
        return this.http.post(API.CUSTOMER + "/GetBillingAccountLookup", customerdetail).pipe(map(res => res.json()));
    }
    searchCustomersLookup(customerdetail: CustomerDetails): Observable<CustomerDetailsListEntity> {
        return this.http.post(API.CUSTOMER + "/GetCustomerList", customerdetail).pipe(map(res => res.json()));
    }
    //WithCF
    //GetCustomerList
    /**Autocomplete API */
    customerlookup(CustomerId: number, keyword: string) {
        return this.http.get(API.CUSTOMER + "/CustomerLookup/" + CustomerId + "/" + keyword).pipe(map(res => res.json()));
    }
    GetBillingAddressName(companyId: number, customerId: number, billingCustomerId: number, billingAccountId: number) {
        return this.http.get(API.CUSTOMER + '/GetBillingAddressName/?CompanyId=' + companyId + '&CustomerId=' + customerId + '&BillingCustomerId=' + billingCustomerId + '&BillingAccountId=' + billingAccountId).pipe(map(resp => resp.json()));
    }
    GetBillingAddress(companyId: number, customerId: number, customerAddressId: number) {
        return this.http.get(API.CUSTOMER + '/GetBillingAddress/?CompanyId=' + companyId + '&CustomerId=' + customerId + '&CustomerAddressId=' + customerAddressId).pipe(map(resp => resp.json()));
    }
    /**Get Customer Notes & Instructions */
    GetCustomerNotes(CompanyId: number, CustomerId: number, NotesMasterId: number) {
        return this.http.get(API.WORKORDER + "/GetCustomerNotes/" + CompanyId + "/" + CustomerId + "/" + NotesMasterId).pipe(map(resp => resp.json()));
    }
    /**Save Special Notes */
    AddCustomerNotes(Notes: Specialinfo): Observable<FPResponse> {
        return this.http.post(API.WORKORDER + "/InsertCustomerNotes", Notes).pipe(map(resp => resp.json()));
    }
    /**Update Special Notes*/
    EditCustomerNotes(Notes: Specialinfo): Observable<FPResponse> {
        return this.http.put(API.WORKORDER + "/UpdateCustomerNotes", Notes).pipe(map(resp => resp.json()));
    }
    /**Delet Special Notes*/
    DeleteCustomerNotes(CompanyId: number, NotesId: number) {
        return this.http.delete(API.WORKORDER + "/DeleteCustomerNotes/" + CompanyId + "/" + NotesId).pipe(map(resp => resp.json()));
    }
    getPaswordComplexity(CompanyId: number, Password: string): Observable<string[]> {
        // return this.http.get(API.SYSTEMSETTING + "/GetPaswordComplexity/" + CompanyId+ "/?Password=" + Password).map<string[]>(res => res.json());

        return this.http.post(API.SYSTEMSETTING + "/GetPaswordComplexity/" + CompanyId, { 'Password': Password }).pipe(map(res => res.json()));
    }
    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }

    getCustomerPrefTech(customerId: number, p: PagerList): Observable<CustomerPreferTechListEntity> {
        return this.http.get(API.CUSTOMER + '/GetCustTechPreference/?CompanyId=' + p.CompanyId + '&CustomerId=' + customerId + '&SortBy=' + p.SortBy + '&StartRecord=' + p.StartRecord + '&EndRecord=' + p.EndRecord).pipe(map(this.extractData));
    }

    getVendor(CompanyId: number, Id: number): Observable<Vendor[]> {
        return this.http.get(API.VENDOR + "/GetVendor/" + Id + "/" + CompanyId).pipe(map(res => res.json()));
    }

    getTechnicians(CompanyId: number, LogindId: number, VendorId: number, MaxRoleGroup: number): Observable<Technician[]> {

        return this.http.get(API.USER + "/GetTechAllDropDown/" + '?CompanyId=' + CompanyId +
            '&VendorId=' + VendorId +
            '&LoginId=' + LogindId +
            '&MaxRoleGroup=' + MaxRoleGroup +
            '&IsActive=' + 1).pipe(map(this.extractData));
    }

    getCustTechPref(CompanyId: number, Id: number): Observable<CustomerPreferTech> {
        return this.http.get(API.CUSTOMER + "/GetCustTechPref/" + CompanyId + "/" + Id).pipe(map(res => res.json()));
    }

    insertCustomerPrefTech(customerpreftech: CustomerPreferTech): Observable<FPResponse> {
        return this.http.post(API.CUSTOMER + "/InsertCustTechPref/", customerpreftech).pipe(map(res => res.json()));
    }

    updateCustomerPrefTech(customerpreftech: CustomerPreferTech): Observable<FPResponse> {
        return this.http.put(API.CUSTOMER + "/UpdateCustTechPref/", customerpreftech).pipe(map(res => res.json()));
    }

    deleteCustomerPrefTech(CompanyId: number, CustomerPrefTechId: number): Observable<FPResponse> {
        return this.http.delete(API.CUSTOMER + "/DeleteCustTechPref/" + CompanyId + '/' + CustomerPrefTechId).pipe(map(res => res.json()));
    }

    getCustomerType(CompanyId: number): Observable<CustomerPreferType[]> {
        return this.http.get(API.CUSTOMER + "/GetCustomerType/" + CompanyId).pipe(map(res => res.json()));
    }
    getPMList(companyId: number, customerId: number, searchText: string, p: PagerList): Observable<CustomerPMList> {
        return this.http.get(API.PM + '/GetAllCustomerPM/?CompanyId=' + companyId + '&CustomerId=' + customerId + '&SortBy=' + p.SortBy + '&StartRecord=' + p.StartRecord + '&EndRecord=' + p.EndRecord + '&SearchText=' + searchText).pipe(map(res => res.json()));
    }

    getBrandList(CompanyId: number): Observable<BrandList[]> {
        return this.http.get(API.PART + '/GetBrandList/' + CompanyId).pipe(map(res => res.json()));
    }
    getModelList(CompanyId: number, brandId: number): Observable<ModelList[]> {
        return this.http.get(API.PART + '/GetModelList/' + CompanyId + '/' + brandId).pipe(map(res => res.json()));
    }

    getBusinessHour(companyId: number, customerId: number): Observable<BusinessHour> {

        return this.http.get(API.CUSTOMER + '/GetBusinessHour?CompanyId=' + companyId + '&CustomerId=' + customerId).pipe(map(res => res.json()));
    }
    GetContractType(CompanyId: number): Observable<ContractType[]> {
        return this.http.get(API.MODEL + '/GetContract/' + CompanyId).pipe(map(res => res.json()));
    }
    getContract(CompanyId: number): Observable<ContractType[]> {debugger
      console.log('GetContract');  return this.http.get(API.BRAND + '/GetContract/' + CompanyId).pipe(map(res => res.json()));
    }
    
    updateBusinessHour(businessHour: BusinessHour[]): Observable<FPResponse> {
        return this.http.put(API.CUSTOMER + '/UpdateCustomerBusinessHour', businessHour).pipe(map(res => res.json()));
    }

    getPriorities(CompanyId: number): Observable<Priority[]> {
        return this.http.get(API.WOPRIORITY + "/GetPriorities/" + CompanyId).pipe(map(res => res.json()));
    }

    pushCustomerToThirdPartySystems(customer: Customer): Observable<FPResponse> {
        return this.http.post(API.CUSTOMER + '/PushCustomerToThirdPartySystems', customer).pipe(map(res => res.json()));
    }

    PushCustomerAddressToThirdPartySystems(custAddress: CustomerAddress): Observable<FPResponse> {
        return this.http.post(API.CUSTOMER + '/PushCustomerAddressToThirdPartySystems', custAddress).pipe(map(res => res.json()));
    }

    PushCustomerContactToThirdPartySystems(custContact: CustomerContact): Observable<FPResponse> {
        return this.http.post(API.CUSTOMER + '/PushCustomerContactToThirdPartySystems', custContact).pipe(map(res => res.json()));
    }

    DeleteERPCustomer(companyId: number, customerId: number): Observable<FPResponse> {
        return this.http.post(API.CUSTOMER + '/DeleteERPCustomer/' + companyId + '/' + customerId, null).pipe(map(res => res.json()));
    }
    getcustomerAttachment(CompanyId: number, CustomerId: number): Observable<CustomerAttachmentEntity[]> {
        return this.http.get(API.CUSTOMER + '/GetcustomerAttachment?CompanyId=' + CompanyId + '&CustomerId=' + CustomerId).pipe(map(this.extractData));

    }
    GetCustomerExcelDownload(CompanyId: number, CustomerId: number, CustomerAttachmentId: number, FileName: string) {
        var url = API.CUSTOMER + "/GetCustomerExcelDownload?CompanyId=" + CompanyId + "&CustomerId=" + CustomerId + "&CustomerAttachmentId=" + CustomerAttachmentId + "&FileName=" + FileName;
        return this.http.get(url, { responseType: ResponseContentType.Blob }).pipe();

    }
    deleteCustomerAttachment(CompanyId: number, CustomerId: number, CustomerAttachmentId: number): Observable<FPResponse> {
        
        return this.http.delete(API.CUSTOMER + '/DeleteCustomerAttachment?CompanyId=' + CompanyId + '&CustomerId=' + CustomerId + '&CustomerAttachmentId=' + CustomerAttachmentId).pipe(map(this.extractData));

    }
    insertTaskAttachment(customerAttachment: CustomerAttachment): Observable<FPResponse> {
        
        return this.http.post(API.CUSTOMER + '/CustomerAttachmentInsert', customerAttachment).pipe(
            map(this.extractData));
    }
    checkWorkOrderExist(CompanyId: number, WoId: string, IsTech: boolean, LoginId: number, MaxRoleGroup: number, VendorId: number, TypeId: number, IsManager: boolean) {
        return this.http.get(API.WORKORDER + "/CheckWorkOrderExist/" + WoId + "/" + CompanyId + "/" + IsTech + "/" + LoginId + "/" + MaxRoleGroup + "/" + VendorId + "/" + TypeId + "/" + IsManager).pipe(map(res => res.json()));
    }

    saveCustAttachement(custAttachment: CustomerAttachment[]) {
        
        return this.http.post(API.CUSTOMER + '/InsertCustomerAttachment', custAttachment).pipe(
            map(this.extractData));
    }
    updateCustomerAttachment(custAttachment: CustomerAttachment) {
        
        return this.http.post(API.CUSTOMER + '/UpdateCustomerAttachment', custAttachment).pipe(
            map(this.extractData));
    }
    getPhotoDocumentDetails(companyId: number, configMasterId: number): Observable<ConfigMasterEntity[]> {
        return this.http.get(API.CONFIGMASTER + '/GetAll' + '?CompanyID=' + companyId + '&ConfigID=' + configMasterId).pipe(
            map(this.extractData));
    }

    getVendorList(CompanyId: number, LoginId: number, MaxRoleGroup: number, ProjectId: number, VendorId?: number): Observable<Vendor[]> {
        return this.http.get(API.USER + "/GetVendorList/" + CompanyId + "/" + LoginId + "/" + MaxRoleGroup + "/?ProjectId=" + ProjectId + '&VendorId=' + VendorId).pipe(map(res => res.json()));
    }

    getEnableCustomerMasterPassword(CompanyId: number) {
        return this.http.get(API.COMPANY + "/GetEnableCustomerMasterPassword/" + CompanyId).pipe(map(resp => resp.json()));
    }

    GetEnablePreferredVendor(companyId: number) {
        return this.http.get(API.COMPANY + '/GetEnablePreferredVendor/?CompanyId=' + companyId).pipe(map(resp => resp.json()));
    }


    getAvailableCustVendor(companyId: number, customerId: number): Observable<CustomerVendor[]> {
        return this.http.get(API.CUSTOMER + '/GetAvailableVendors?CompanyId=' + companyId + '&CustomerId=' + customerId).pipe(map(res => res.json()));
    }

    getAllottedCustVendor(companyId: number, customerId: number): Observable<CustomerVendor[]> {
        return this.http.get(API.CUSTOMER + '/GetAllotedVendors?CompanyId=' + companyId + '&CustomerId=' + customerId).pipe(map(res => res.json()));
    }

    updateVendorCustomer(selectedCustVendor: CustomerVendorEntity): Observable<FPResponse> {
        return this.http.put(API.CUSTOMER + '/InsertAllotedVendors', selectedCustVendor).pipe(map(res => res.json()));
    }

    getVendorMapped(CompanyId:number,CustomerId:number): Observable<FPResponse> {
        return this.http.get(API.CUSTOMER + "/GetVendorMapped?CompanyId="+CompanyId+"&CustomerId="+CustomerId).pipe(map(resp => resp.json()));
    }

   

    AddCustomerAndAddress(customer: AddCustomerEntity): Observable<FPResponse> {
        return this.http.post(API.CUSTOMER + '/AddCustomerAndAddress', customer).pipe(map(res => res.json()));
    }

    //Elixir specific
    getCustomerMultipleLogin(CompanyId:number,CustomerId:number): Observable<CustomerMultipleLogin[]> {
        return this.http.get(API.CUSTOMER + '/GetMultipleLoginCustomer/?CompanyId=' + CompanyId + '&CustomerId=' + CustomerId).pipe(map(res => res.json()));
    }
    InsertMultipleLoginCustomer(customer: CustomerMultipleLogin): Observable<FPResponse> {
        return this.http.post(API.CUSTOMER + '/InsertMultipleLoginCustomer', customer).pipe(map(res => res.json()));
    }
    getEnableCustomerMultipleLogin(companyId: number, customerId: number) {
        return this.http.get(API.CUSTOMER + '/getEnableCustomerMultipleLogin?CompanyId=' + companyId + '&CustomerId=' + customerId).pipe(map(res => res.json()));
    }

}